import { useEffect, useState } from 'react';
import { auth } from '../firebase';

// Ringkasan langganan Flow pelanggan untuk kad "Flow subscription" di My Plan (profil).
// Guna endpoint yang SAMA (/customer/overview) dengan halaman Flow Google — TIADA server/medan
// baharu. `sub` = langganan utama (tamat paling lewat) atau null (tiada Flow). `stat` = [tone, kunci]
// status (kunci kongsi fc.sub*). Satu panggilan sekali bila halaman dibuka (bukan poll). Mod pelan
// reka bentuk → enabled=false (tiada server). TWIN: src/components/FlowCustomerView.jsx (sumber data + API).
const API = import.meta.env.VITE_FLOW_SESSION_API || 'https://asia-southeast1-ai8saat.cloudfunctions.net/flowSessionPilot';

// Status dikira di sini (callback, bukan badan render komponen) supaya tiada Date.now() semasa render.
function statusLangganan(sub) {
    if (!sub) return null;
    const aktif = sub.expiresAt ? sub.expiresAt > Date.now() : sub.active;
    const hari = sub.expiresAt ? Math.ceil((sub.expiresAt - Date.now()) / 86400000) : null;
    return !aktif ? ['stop', 'fc.subExpired'] : (hari != null && hari <= 7) ? ['warn', 'fc.subExpiring'] : ['ok', 'fc.subActive'];
}

export function useFlowLangganan(enabled = true) {
    const [state, setState] = useState({ loading: !!enabled, error: false, sub: null, stat: null });
    useEffect(() => {
        if (!enabled) { setState({ loading: false, error: false, sub: null, stat: null }); return; }
        let batal = false;
        setState({ loading: true, error: false, sub: null, stat: null });
        (async () => {
            try {
                await auth.authStateReady();
                if (!auth.currentUser) { if (!batal) setState({ loading: false, error: false, sub: null, stat: null }); return; }
                const r = await fetch(API + '/customer/overview', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + await auth.currentUser.getIdToken() },
                    body: '{}', credentials: 'omit', cache: 'no-store', signal: AbortSignal.timeout(30000),
                });
                if (!r.ok) throw new Error();
                const d = await r.json();
                // `subscription` (tunggal) = langganan utama yang server dah derive (serasi ke belakang).
                const sub = d?.subscription || null;
                if (!batal) setState({ loading: false, error: false, sub, stat: statusLangganan(sub) });
            } catch {
                // Gagal baca = "tak tahu", BUKAN "tiada Flow" — jangan tunjuk ajakan "Get Flow" palsu.
                if (!batal) setState({ loading: false, error: true, sub: null, stat: null });
            }
        })();
        return () => { batal = true; };
    }, [enabled]);
    return state;
}
